var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { MeasurementsClient, CompaniesClient, SitesClient, GetDataGapsQuery, DataGapModel, DataGapSettingsModel, UpsertDataGapsSettingsCommand } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { DatePresetOption } from "@/common/enums/date-preset";
import moment from 'moment';
const companiesClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const measurementsClient = new MeasurementsClient(window.apiUrl);
let DataGapsVue = class DataGapsVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.activeTab = 0;
        this.showConfigModal = false;
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig(false);
        this.timePickerConfig = {
            dateFormat: "H:i",
            wrap: true,
            enableTime: true,
            noCalendar: true,
            time_24hr: true,
            allowInput: true
        };
        this.dateFilterOptions = ["Week", "Month", "3 Months", "Year", "..."];
        this.dateFilterOption = "";
        this.companies = [];
        this.sites = [];
        this.query = new GetDataGapsQuery();
        this.data = new DataGapModel();
        this.settingsModel = new DataGapSettingsModel({ timeScheduled: "12:00" });
        this.showOnlyCompaniesSelected = false;
        this.expandedStringGroups = {};
        this.expandedBlockSystems = {};
        this.expandedBlockComponents = {};
        this.expandedMeasurementSystems = {};
        this.expandedMeasurementTypes = {};
        this.expandedMeasurementComponents = {};
    }
    created() {
        this.getCompanies();
        this.getSites();
    }
    ;
    getCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            this.working = true;
            return yield companiesClient
                .getListGET()
                .then(response => {
                this.companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                if (!this.companies.length)
                    return;
                if (this.query.companyId)
                    return;
                let companyId = this.companies[0].value;
                this.query.companyId = companyId;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.resetDateFilterOption();
            });
        });
    }
    ;
    getSites() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            });
        });
    }
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        let query = this.query;
        if (query.companyId == null) {
            this.working = false;
            Notifier.onWarning(`Please select a company!`);
            return;
        }
        query.startTime = query.startTime ? DateHelper.convertToDate(query.startTime.toString()) : null;
        query.endTime = query.endTime ? DateHelper.convertToDate(query.endTime.toString()) : null;
        if (query.endTime != null)
            query.endTime = DateHelper.getEndOfDay(query.endTime);
        if (!DateHelper.validateDateRange(query.startTime, query.endTime)) {
            this.working = false;
            Notifier.onWarning(`Please enter valid dates. The start date must be before the end date.`);
            return;
        }
        this.working = true;
        measurementsClient
            .getDataGap(query)
            .then((response) => {
            this.data = response;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onCompanyIdChanged() {
        this.query.siteId = null;
    }
    get companyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set companyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => this.query.companyId == null || this.query.companyId == site.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get siteId() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set siteId(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    resetDateFilterOption() {
        this.setDateFilterOption("Week");
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
        if (this.dateFilterOption == "...")
            return;
        this.setDateRange();
    }
    ;
    setDateRange() {
        let range = DateHelper.getDateRange(DatePresetOption.oneWeek);
        let now = new Date();
        let end = moment(now.toISOString()).endOf("day").toDate();
        switch (this.dateFilterOption) {
            case "Week":
                range = DateHelper.getDateRange(DatePresetOption.SevenDays);
                break;
            case "Month":
                range = DateHelper.getDateRange(DatePresetOption.OneMonth);
                break;
            case "3 Months":
                range = DateHelper.getDateRange(DatePresetOption.ThreeMonths);
                break;
            case "Year":
                range = DateHelper.getDateRange(DatePresetOption.OneYear);
                break;
        }
        if (!range)
            return;
        this.query.startTime = moment(range.start).subtract(2, "days").toDate();
        this.query.endTime = moment(range.end).subtract(2, "days").toDate();
    }
    ;
    get areDatesInvalid() {
        if (this.query.startTime == null || this.query.endTime == null || this.startDateInvalid || this.endDateInvalid)
            return false;
        let startTime = DateHelper.convertToDate(this.query.startTime.toString());
        let endTime = DateHelper.convertToDate(this.query.endTime.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.query.startTime)
            return true;
        try {
            return isNaN(Date.parse(this.query.startTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.query.endTime)
            return true;
        try {
            return isNaN(Date.parse(this.query.endTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get noStringSnapshotData() {
        return this.searchAttempted && (!this.data || !this.data.stringSnapshotGaps || !this.data.stringSnapshotGaps.length);
    }
    get noBlockSnapshotData() {
        var _a;
        return this.searchAttempted && !((_a = this.data.blockSnapshotGaps) === null || _a === void 0 ? void 0 : _a.length);
    }
    get noMeasurementData() {
        var _a;
        return this.searchAttempted && !((_a = this.data.measurementGaps) === null || _a === void 0 ? void 0 : _a.length);
    }
    getDateFormated(date, seconds = false) {
        if (!date)
            return "";
        return moment(date).format(seconds ? "DD MMM YYYY HH:mm:ss" : "DD MMM YYYY");
    }
    get groupedStringGaps() {
        const groups = {};
        for (const item of this.data.stringSnapshotGaps || []) {
            const id = item.systemId;
            if (!groups[id]) {
                groups[id] = {
                    systemName: item.systemName,
                    items: []
                };
            }
            groups[id].items.push(item);
        }
        return groups;
    }
    get groupedBlockGapsBySystem() {
        const grouped = {};
        for (const item of this.data.blockSnapshotGaps || []) {
            const sysId = item.systemId;
            const compId = item.componentId;
            if (!grouped[sysId]) {
                grouped[sysId] = {
                    systemName: item.systemName,
                    totalCount: 0,
                    components: {}
                };
            }
            if (!grouped[sysId].components[compId]) {
                grouped[sysId].components[compId] = {
                    componentName: item.componentName,
                    items: []
                };
            }
            grouped[sysId].components[compId].items.push(item);
            grouped[sysId].totalCount++;
        }
        return grouped;
    }
    toggleBlockSystem(systemId) {
        this.expandedBlockSystems[systemId] = !this.expandedBlockSystems[systemId];
    }
    toggleBlockComponent(componentId) {
        this.expandedBlockComponents[componentId] = !this.expandedBlockComponents[componentId];
    }
    get groupedMeasurementGaps() {
        const grouped = {};
        for (const item of this.data.measurementGaps || []) {
            const sysId = item.systemId;
            const measTypeId = item.measurementTypeId;
            const compId = item.componentId;
            if (!grouped[sysId]) {
                grouped[sysId] = {
                    systemName: item.systemName,
                    totalCount: 0,
                    measurements: {}
                };
            }
            if (!grouped[sysId].measurements[measTypeId]) {
                grouped[sysId].measurements[measTypeId] = {
                    measurementName: item.measurementName,
                    components: {}
                };
            }
            if (!grouped[sysId].measurements[measTypeId].components[compId]) {
                grouped[sysId].measurements[measTypeId].components[compId] = {
                    componentName: item.componentName,
                    items: []
                };
            }
            grouped[sysId].measurements[measTypeId].components[compId].items.push(item);
            grouped[sysId].totalCount++;
        }
        return grouped;
    }
    toggleMeasurementSystem(systemId) {
        this.expandedMeasurementSystems[systemId] = !this.expandedMeasurementSystems[systemId];
    }
    toggleMeasurementType(measurementTypeId) {
        this.expandedMeasurementTypes[measurementTypeId] = !this.expandedMeasurementTypes[measurementTypeId];
    }
    toggleMeasurementComponent(componentId) {
        this.expandedMeasurementComponents[componentId] = !this.expandedMeasurementComponents[componentId];
    }
    getSettings() {
        this.working = true;
        measurementsClient.getGapsSetting()
            .then((response) => {
            this.settingsModel = response;
            if (!this.settingsModel.timeScheduled)
                this.settingsModel.timeScheduled = "12:00";
            if (!this.settingsModel.companyIdsToExclude)
                this.settingsModel.companyIdsToExclude = [];
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    showConfig() {
        this.getSettings();
        this.showConfigModal = true;
    }
    save() {
        var _a;
        if (this.settingsModel.enabled) {
            if (!((_a = this.settingsModel.emailAddresses) === null || _a === void 0 ? void 0 : _a.trim())) {
                Notifier.onWarning("Enter at least one email address!");
                return;
            }
        }
        this.working = true;
        measurementsClient.upsertDataGapsSetting(new UpsertDataGapsSettingsCommand({ requestModel: this.settingsModel })).
            then(() => {
            Notifier.onOk();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    cancel() {
        this.showConfigModal = false;
    }
    selectedCompaniesCount() {
        var _a, _b, _c;
        var count = (_c = (_b = (_a = this.settingsModel) === null || _a === void 0 ? void 0 : _a.companyIdsToExclude) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        this.showOnlyCompaniesSelected = count == 0 ? false : this.showOnlyCompaniesSelected;
        return count;
    }
    selectCompany(item) {
        var _a, _b;
        var idx = (_b = (_a = this.settingsModel) === null || _a === void 0 ? void 0 : _a.companyIdsToExclude) === null || _b === void 0 ? void 0 : _b.indexOf(item.value);
        if (idx >= 0)
            this.settingsModel.companyIdsToExclude = this.settingsModel.companyIdsToExclude.filter(id => id != item.value);
        else
            this.settingsModel.companyIdsToExclude.push(item.value);
    }
    isCompanySelected(item) {
        var _a, _b;
        return (_b = (_a = this.settingsModel) === null || _a === void 0 ? void 0 : _a.companyIdsToExclude) === null || _b === void 0 ? void 0 : _b.includes(item.value);
    }
    //get companiesForSchedule(): ListOption[] {
    //	return this.companies.filter(item => !this.showOnlyCompaniesSelected || this.settingsModel.companyIdsToExclude?.includes(item.value));
    //}
    canShowCompany(item) {
        var _a;
        return !this.showOnlyCompaniesSelected || ((_a = this.settingsModel.companyIdsToExclude) === null || _a === void 0 ? void 0 : _a.includes(item.value));
    }
};
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataGapsVue.prototype, "onCompanyIdChanged", null);
DataGapsVue = __decorate([
    Component({
        name: "DataGapsVue"
    })
], DataGapsVue);
export default DataGapsVue;
